import React from "react";
import HomeHero from "../../components/userSideComponents/Home/HomeHero";
import PropertyCardSection from "../../components/userSideComponents/Home/PropertyCardSection";
import OurProcess from "../../components/userSideComponents/Home/OurProcess";
// import TrustNumbers from "../../components/userSideComponents/Home/TrustNumbers";
import WhyChooseUs from "../../components/userSideComponents/Home/WhyChooseUs";
import FaqSection from "../../components/userSideComponents/Home/FaqSection";
import Testimonials from "../../components/userSideComponents/Home/Testimonials";
import GetInTouch from "../../components/userSideComponents/Home/GetInTouch";

const Home = () => (
  <div>
    <HomeHero />
    <PropertyCardSection />
    <OurProcess />
    {/* <TrustNumbers /> */}
    <WhyChooseUs />
    <Testimonials />
    <FaqSection />
    <GetInTouch />
  </div>
);

export default Home;
